'use client'
import useRouter from '@/src/hooks/Router/useRouter'
import useEventListener from '@/src/hooks/useEventListener'
import { RefObject } from 'react'

type PlayNGoFrameType = {
  url: string
  className: string
  iframeRef: RefObject<HTMLIFrameElement | null>
}

const PlayNGoFrame = ({ url, className, iframeRef }: PlayNGoFrameType) => {
  const router = useRouter()
  useEventListener('message', (e) => {
    if (e.data && e.data.type === 'backToLobby') router.push('/')
    if (e.data && e.data.type === 'reloadGame') router.refresh()
  })

  const preparePlayNGo = () => {
    const urlObj = new URL(url)
    const iFrameElement = iframeRef && iframeRef.current
    if (iFrameElement?.contentWindow) {
      iFrameElement.contentWindow.postMessage(
        {
          messageType: 'addEventListener',
          eventType: 'backToLobby',
        },
        urlObj.origin,
      )
      iFrameElement.contentWindow.postMessage(
        {
          messageType: 'addEventListener',
          eventType: 'reloadGame',
        },
        urlObj.origin,
      )
    }
  }

  useEventListener('load', () => preparePlayNGo(), iframeRef)

  return (
    <iframe
      data-testid='game-iframe'
      ref={iframeRef}
      src={url}
      className={className}
      scrolling='no'
    />
  )
}

export default PlayNGoFrame
